<div class="building-option-container">
  <div class="building-option" *ngFor="let building of data; trackBy: trackByIdentity" (click)="onSelect(building)">
    <div class="building-icon" *ngIf="building.marker.options.data.icon !== undefined">
      <img [src]="building.marker.options.data.icon" alt="building-marker" />
    </div>
    <div class="building-details">
      <div>
        <span class="label-color label-sm"
          >{{
            building.status === 'nogps'
              ? building.marker.options.data.buildingType
                ? building.marker.options.data.buildingType.name
                : ''
              : 'Unbekanntes Objekt'
          }}
        </span>
      </div>
      <span class="address">{{ building.marker.options.data | getAddress }}</span>
      <div class="meter-details">
        <div class="meter-list">
          <span class="label-color label-xs">Zählernummer</span>
        </div>
        <div class="meter-list">
          <div class="meter-number" *ngFor="let meter of building.marker.options.data.meters; trackBy: trackByFnMeter">
            {{ meter.meterNumber }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
